module.exports = __webpack_public_path__ + "assets/images/fox.9b1fcf72ae80881f57e8148f37bb0c10.png";